export default __webpack_public_path__ + "files/thumbnail-4732ea2333085288d1065c7a3a7cf77d.png";